import { mapActivityFeed } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/activityFeed.utils';
import { loanActivityApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop.
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

const ACTIVITY_SINCE_DAYS = 7;

export const COMMAND_CENTER_ACTIVITY_FEED_ACTION_TYPE = createNamedActions(
  'commandCenterActivityFeed',
  {
    SET_ACTIVITY_FEED: 'SET_ACTIVITY_FEED',
  },
);

export const getCommandCenterActivityFeedAction = catchAsyncActionError(() => async dispatch => {
  try {
    const { data } = await loanActivityApi.getActivitySince({
      sinceDays: ACTIVITY_SINCE_DAYS,
      config: SKIP_FORBIDDEN_CONFIG,
    });

    return dispatch({
      type: COMMAND_CENTER_ACTIVITY_FEED_ACTION_TYPE.SET_ACTIVITY_FEED,
      payload: mapActivityFeed(data ?? null),
    });
  } finally {
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.ACTIVITY_FEED));
  }
});
